import type { PrismTheme } from "prism-react-renderer/src/types.js";

var theme: PrismTheme = {
  plain: {
    color: "var(--color-headingFont)",
    backgroundColor: "var(--color-background)",
  },
  styles: [
    {
      types: ["prolog"],
      style: {
        color: "rgb(0, 0, 128)"
      }
    },
    {
      types: ["comment"],
      style: {
        color: "var(--color-gray2)"
      }
    },
    {
      types: ["builtin", "changed", "keyword"],
      style: {
        color: "var(--color-secondary)"
      }
    },
    {
      types: ["number", "inserted"],
      style: {
        color: '#a8e063'
      }
    },
    {
      types: ["constant"],
      style: {
        color: "var(--color-primary)"
      }
    },
    {
      types: ["attr-name", "variable"],
      style: {
        color: '#a8e063'
      }
    },
    {
      types: ["deleted", "string", "attr-value"],
      style: {
        color: "var(--color-headingFont)"
      }
    },
    {
      types: ["selector"],
      style: {
        color: "rgb(255, 64, 153)"
      }
    },
    {
      // Fix tag color
      types: ["tag"],
      style: {
        color: "var(--color-primary)"
      }
    },
    {
      // Fix tag color for HTML
      types: ["tag"],
      languages: ["markup"],
      style: {
        color: "var(--color-primary)"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "var(--color-gray1)"
      }
    },
    {
      // Fix punctuation color for HTML
      types: ["punctuation"],
      languages: ["markup"],
      style: {
        color: "var(--color-gray2)"
      }
    },
    {
      types: ["function"],
      style: {
        color: "var(--color-primary)"
      }
    },
    {
      types: ["class-name"],
      style: {
        color: '#a8e063'

      }
    },
    {
      types: ["char"],
      style: {
        color: "var(--color-primary)"
      }
    }
  ]
};

export default theme;